import { render, staticRenderFns } from "./AuctionDescription.vue?vue&type=template&id=ec9dafb2&"
import script from "./AuctionDescription.vue?vue&type=script&lang=js&"
export * from "./AuctionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports